<template>

    <v-action name="Image">
        <div class="uploader">
            <div class="uploader-body">
                <input ref="file" type="file" name="file" @change="uploadImage" />
                <div v-if="loading" class="uploader-loader"><v-loader /></div>
                <div class="image" v-if="block.src" :style="{ 'background-image': `url(${block.src})` }"></div>
            </div>
        </div>
        <v-button-toolbar size="sm">
            <v-button
                class="mt-5"
                btn-label="Select Image"
                size="xs"
                btn-style="white"
                @click.native.prevent="$refs.file.click()">
            </v-button>
            <v-button v-if="block.src !== block.placeholder"
                class="mt-5"
                btn-label="Remove"
                size="xs"
                btn-style="white-danger"
                @click.native.prevent="setImage(block.placeholder)">
            </v-button>
        </v-button-toolbar>
    </v-action>

</template>

<style scoped lang="scss">

    .uploader {

        background: #fff;
        border: 1px solid $color-rule;
        border-radius: 3px;
        padding: 5px;
        transition: border-color .3s;
        &:hover {
            border-color: $color-text;
        }

        .uploader-loader {
            align-items: center;
            background: rgba(255,255,255,0.9);
            display: flex;
            height: 100%;
            justify-content: center;
            position: absolute;
            width: 100%;
            z-index: 1;
        }

        .uploader-body {
            background: $color-bg;
            height: 100px;
            overflow: hidden;
            position: relative;
            width: 100%;
            input[type=file] {
                background: transparent;
                cursor: pointer;
                height: 100%;
                left: 0;
                margin: 0;
                opacity: 0;
                padding: 0;
                position: absolute;
                top: 0;
                width: 100%;
                z-index: 2;
            }
            .image {
                background-position: center;
                background-repeat: no-repeat;
                background-size: contain;
                border-radius: 3px;
                height: 100%;
                width: 100%;
            }
        }

    }

</style>

<script>

import Action from './Action';
import ImageApi from '@api/ImageApi';

export default {

    components: {
        'v-action': Action,
    },

    data() {
        return {
            loading: false,
            error: null,
        }
    },

    computed: {

        block() {
            return this.$store.getters['builder/selectedBlock'];
        },

    },

    methods: {

        uploadImage() {
            let file = this.$refs.file.files[0];
            if (file) {
                this.loading = true;
                this.error = null;
                let params = new FormData();
                params.append('file', file);
                ImageApi.createImage(params)
                    .then((response) => {
                        this.loading = false;
                        this.error = null;
                        this.setImage(response.data.data.s3_link);
                    }, (error) => {
                        this.loading = false;
                        this.$store.commit('setAlertWithError', error);
                    });
            }
        },

        setImage(val = '') {
            let block = this.block;
            block['src'] = val;
            this.$store.commit('builder/setSelectedBlock', block);
        },

    },

}

</script>